/* eslint-disable */
import Vue from 'vue';
import ShardsVue from 'particle-vue';

// Styles
import 'particle-ui/dist/particle-ui-app.css';
import '@/scss/dashboards.scss';
import '@/assets/scss/date-range.scss';
import "jsoneditor/dist/jsoneditor.min.css";

// Core
import App from './App.vue';
import router from './router';
import store from './store/store';
// import Axios from 'axios';


import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme

import VueFormGenerator from "vue-form-generator";
import jsonField from "./components/forms/jsonField.vue";
import fileUploadField from "./components/forms/fileUploadField.vue";
import asyncButton from "./components/common/AsyncButton";

import Toasted from "vue-toasted";

import Scrollspy from "vue2-scrollspy";

Vue.use(Scrollspy);

Vue.use(Toasted);

Vue.component("async-button",asyncButton);
Vue.component("field-jsonField", jsonField);
Vue.component("field-fileUploadField", fileUploadField);
Vue.use(VueFormGenerator);

ShardsVue.install(Vue);

// https://github.com/dm4t2/vue-currency-input
import VueCurrencyInput from "vue-currency-input";
const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: "USD", locale: "en", valueAsInteger: true, distractionFree: false, autoDecimalModel: true }
};
Vue.use(VueCurrencyInput, pluginOptions)

// Layouts
import Default from '@/layouts/Default.vue';
Vue.component('default-layout', Default);

import Simple from '@/layouts/Simple.vue';
Vue.component('simple-layout', Simple);

import Loading from '@/components/common/Loading.vue';
Vue.component('loading', Loading);

import PageHeader from "@/components/layout/Page/Header.vue";
Vue.component("page-header", PageHeader);

Vue.config.productionTip = false;


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
